import { Link } from "react-router-dom";

export default function FeatureCard({ label, description, cards }) {
  return (
    <section className="bg-[#f7faff] p-8">
      <div className="container mx-auto text-center mb-10 max-w-[865px]">
        <h2 className="text-2xl md:text-3xl font-bold text-custom-blue mt-2">
          {label}
        </h2>
        <p className="text-gray-600 text-sm md:text-base font-normal mt-2.5">
          {description}
        </p>
      </div>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {cards.map((job, index) => (
          <div
            key={index}
            className="bg-white shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border-[22px] border-white rounded-[10px]"
          >
            <img
              src={job.image}
              alt={job.title}
              className="w-full h-48 object-cover"
            />
            <div>
              <h3 className="text-xl font-bold text-gray-900 my-2">
                {job.title}
              </h3>
              <p className="text-gray-600 text-sm md:text-base mb-4">
                {job.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center mt-8">
        <Link
          to="/auth/login"
          className="bg-custom-blue text-white font-medium py-2 px-4 rounded hover:bg-blue-700 transition duration-300 w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-xl text-center"
        >
          Signup to explore AI careers aligned with your current Occupation →
        </Link>
      </div>
    </section>
  );
}
